<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NuStqI/tc-custom/9781488091773.jpg?1703710461066" alt="This image is the cover for the book Contract Bride, In Name Only"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contract Bride, In Name Only
      </h1>
      <p class="bookDescription body article font2">
        <b>A green card wedding leads to red hot passion for a sexy billionaire and his Australian consultant in this steamy contemporary romance.</b><br/><br/>All work and no play for reasons he <i>won’t</i> talk about, CEO Warren Garinger is determined to keep his company at the top of the market. So when his ace marketing consultant, Australian Tilda Barrett, announces that she’ll have to leave the country thanks to an immigration mix-up, he’ll do anything to keep her in the States. And the solution is simple enough: a marriage in name only.<br/><br/>But beneath Tilda’s staid suits and severe buns lies the sexiest woman Warren’s ever met. Now their brief wedding kiss is all he can think about. And soon Warren vows to not only marry his convenient wife but bed her, too . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kat Cantrell
      </h2>
      
      <p class="authorDescription body article"><I>USA&#160;TODAY</I> bestselling author KAT CANTRELL read her first Harlequin novel in third grade and has been scribbling in notebooks since she learned to spell. She&#39;s a former Harlequin So You Think You Can Write winner and former RWA Golden Heart finalist. Kat, her husband and their two boys live in north Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4608922